module.exports = __webpack_public_path__ + "img/active_b.070bb417.png";